import React from 'react';
import { Box, Stack } from '@mui/material';
import { AssignmentInd } from '@mui/icons-material';
import { SectionHeaderWithCommand, SectionPaper } from '../../../../common/components';
import {
  DefaultTeamEdit,
  DefaultAssigneeEdit
} from '../fields';

/**
 * AssignmentSection - Contains default assignment information
 */
export const AssignmentSection: React.FC = () => {
  return (
    <Box>
      <SectionHeaderWithCommand
        icon={<AssignmentInd sx={{ mr: 1, color: '#3b82f6', fontSize: 18 }} />}
        title="Default Assignment"
      />
      
      <SectionPaper>
        <Stack direction="row" gap={2}>
          <DefaultTeamEdit />
          <DefaultAssigneeEdit />
        </Stack>
      </SectionPaper>
    </Box>
  );
};

export default AssignmentSection;
